import { BaseRequest } from 'src/app/tools/models/dtos/base-request';
import { UserInfo } from 'src/app/tools/models/entities/user-info';
import { ProductOption } from '../../entities/master-data/product-option-entity';


export class ProductOptionRequest extends BaseRequest{
  productOption : ProductOption;
  constructor(userInfo : UserInfo){    
    super(userInfo);
    this.productOption = new ProductOption();
  }
}